/** Normalize API recommended_products shapes to a deduped flat list. */

export function productIdentity(product) {
  if (!product || typeof product !== 'object') return '';
  return String(product.id || product.product_id || product.sku || product.slug || product.name || '').trim();
}

export function dedupeProductsById(products) {
  if (!Array.isArray(products)) return [];
  const seen = new Set();
  const out = [];
  products.forEach((product) => {
    const key = productIdentity(product);
    if (!key || seen.has(key)) return;
    seen.add(key);
    out.push(product);
  });
  return out;
}

export function flattenRecommendedProducts(recommendedProducts) {
  if (!recommendedProducts) return [];
  if (Array.isArray(recommendedProducts)) {
    return dedupeProductsById(recommendedProducts);
  }
  const morning = recommendedProducts.morning || [];
  const evening = recommendedProducts.evening || [];
  return dedupeProductsById([...morning, ...evening]);
}

export function attachRoutineSessions(products) {
  const sorted = dedupeProductsById(products);
  const morning = [];
  const evening = [];
  sorted.forEach((product) => {
    const routineTime = product.routine_time || [];
    const timeSession = String(product.am_pm || product.time_session || '').toLowerCase();
    const inMorning = routineTime.includes('morning') || timeSession.includes('am');
    const inEvening = routineTime.includes('evening') || timeSession.includes('pm');
    if (inMorning && !inEvening) {
      morning.push(product);
    } else if (inEvening && !inMorning) {
      evening.push(product);
    } else {
      morning.push(product);
    }
  });
  const flat = dedupeProductsById([...morning, ...evening]);
  flat.morning = morning;
  flat.evening = evening;
  return flat;
}
